<template>
  <div ref="manualwizard">
    <!-- <div v-if="!isFinal" class="row justify-content-between">
      <span class="h5 ml-3">Apply with New Candidate </span>
      <b-button class="candidate-button button-white mr-2" size="sm" @click="onClick('onCloseModal', 'createCandidate')">
        <i class="uil-times-circle mr-1" style="font-size: 14px;"></i> 
         Close Window
      </b-button>
    </div> -->
    <!-- <div v-if="isFinal" class="row justify-content-start">
      <h5 class="ml-3" >Submitted Successfully</h5>
    </div> -->

    <Step1 ref="manual_step1" v-if="!isFinal" :data="finalModel.user" :job_id="finalModel.job_id" :candidateID="candidateID" @on-validate="mergePartialModels" @onCLose="onClose" @final-data="setFinalData" />
    <Step55 ref="manual_step5" v-else :data="finalData" @on-validate="mergePartialModels" />
    <div class="row justify-content-end pb-4 px-2">
      <!-- <b-button v-show="!isFinal" class="candidate-button button-white mr-2" size="sm" @click="onClick('onCloseModal', 'createCandidate')">
        {{ $t('common.upload_resume.steps.step2.cancel_button') }}
      </b-button> -->
      <Button :label="!isFinal ? 'Save + View' : 'Send Consent Form'" class="btn2 btn2-primary btn2-md" size="sm" @click="validateStep(`${ !isFinal ? 'manual_step1' : 'manual_step5' }`)"/>
    </div>
  </div>
</template>

<script>
import Step55 from '../steps/step5_5.vue'
import Step1 from '../steps/step1.vue'
import Button from '@components/buttons'

export default {
  components: {
    Step55,
    Step1,
    Button
  },
  props: {
    parameters: {
      type: Object,
      default: () => {}
    }
  },
  computed: {
    finalModel() {
      let parameters = this.parameters || {}
      return parameters.finalModel || {}
    },
    candidateID() {
      let parameters = this.parameters || {}
      return parameters.candidateID
    }
  },
  data () {
    return {
      isFinal: false,
      step: 1,
      finalData: [],
    }
  },
  methods: {
    validateStep(name) {
			var refToValidate = this.$refs[name]
			return refToValidate.validate().then( res => {
        if(res){
          this.isFinal = res
          this.step++
          if(this.step == 3){
            // this.onComplete()
          }
        }
      })
		},
    mergePartialModels(model, isValid, showError = false) {
      if(!showError){
        if (isValid && model) {
          this.$emit('onClick', { method: 'mergePartialModels', model, isValid, showError })
          if(model.candidate_id) {
            this.onComplete(model.candidate_id)
          }
        }
      }else{
        this.$emit('onClick', { method: 'closeAllModals' })
        this.$refs['manual_step1'].reset()
      }
    },
    onComplete(candidateID) {
      this.$emit('onClick', { method: 'onComplete', candidateID })
    },
    onClick(method, bool, isCreated, candidateID) {
      this.$emit('onClick', { method, bool, isCreated, candidateID })
    },
    onCLickExisting() {
      this.onClick('onCloseModal', 'createCandidate')
      this.onClick('modeSelect')
    },
    onClose(val) {
      this.onClick('onCloseModal', 'createCandidate', true, val.candidate_id)
    },
    setFinalData(data) {
      this.finalData = data
    },
  }
}
</script>